"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const i18next_1 = tslib_1.__importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
i18next_1.default.use(react_i18next_1.initReactI18next).init({
    fallbackLng: 'en',
    lng: 'en',
    resources: {},
    keySeparator: '.',
    react: {
        useSuspense: false, // Set to true if you want to use Suspense
    },
    interpolation: {
        escapeValue: false, // Not needed for React as it escapes by default
    },
});
exports.default = i18next_1.default;
//# sourceMappingURL=i18n.js.map